import { jsx } from "react/jsx-runtime";
import { SelectStateProvider } from "./contexts/SelectStateProvider.js";
import { TextsProvider } from "./contexts/texts.js";
function SelectProvider(props) {
  const { texts } = props;
  return /* @__PURE__ */ jsx(TextsProvider, { texts, children: /* @__PURE__ */ jsx(SelectStateProvider, { ...props }) });
}
export {
  SelectProvider
};
//# sourceMappingURL=SelectProvider.js.map
